import PageContainer from '../../core/components/PageContainer';
import PersonalAccessTokens from './PersonalAccessTokens';

const SettingsPage = () => {
    return (
        <PageContainer>
            <PersonalAccessTokens />
        </PageContainer>
    );
};

export default SettingsPage;
